export default "__VITE_ASSET__BeLjhhUv__"